import { filter } from 'rxjs';
import { SetupPreferenceComponent } from '@app/components/setup-preference/setup-preference.component';
import { Type } from '@angular/core';

export interface SettingConfigItem {
  label: string;
  key: string;
  filter_key: string;
  type: 'Select' | 'Input' | 'Checkbox';
  purpose: string;
  roles?: string[];
  bottlerIds?: string[];
  placeholder?: string;
}

export interface SettingConfigTab {
  title: string;
  name: string;
  key: string;
  icon: string;
  // A tab can either have a list of settings items OR a dedicated component
  settings?: SettingConfigItem[]; // Make settings optional
  component?: Type<any>; // Make component optional
  bottlerIds?: string[];
  screenAccess?: string[];
  role?: string;
}

export const settingsConfig: SettingConfigTab[] = [
  {
    title: 'User Settings',
    name: 'User Settings',
    key: 'user-settings',
    icon: 'settings-outline',
    bottlerIds: ['CONA'],
    role: 'ADMIN',
    screenAccess: ['SETTINGS', 'ALL'],
    settings: [
      {
        label: 'Bottler Id',
        key: 'BottlerId',
        filter_key: 'bottlerId',
        type: 'Select',
        placeholder: 'Bottler Id',
        purpose: 'This setting filters the data based on the Bottler Id',
        roles: ['ADMIN', 'FSOP', 'CR'], // Conditions under which this setting is shown
        bottlerIds: ['CONA'], // Conditions under which this setting is shown
      },
      // Consolidation Changes: This setting is currently not required as role is no longer required. We can remove this from the codebase in future if role is not required for any other functionality.
      // {
      //   label: 'Customer Type',
      //   key: 'Role',
      //   filter_key: 'highLevelTc',
      //   type: 'Select',
      //   placeholder: 'Customer Type',
      //   purpose: 'This setting filters the data based on the Customer Type',
      //   roles: ['ADMIN'], // Conditions under which this setting is shown
      //   // bottlerIds: ['CONA'], // Conditions under which this setting is shown
      // },
    ],
  },
  {
    title: 'Rec Preference',
    name: 'Rec Preference',
    key: 'user-preference',
    icon: 'person-add-outline',
    screenAccess: ['RECS', 'ALL'],
    component: SetupPreferenceComponent,
  },
];
